import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCaseDashboardData } from "../../../api/dashboard_api";






export const getDashboardDataAction = createAsyncThunk(
   "dashboard/getDashboardDataAction", async (values, { rejectWithValue, getState }) => {
    try {
      const { userId, orgIds, year, chartYear }=values;
    const data = await getCaseDashboardData(userId, orgIds, year, chartYear);
    return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
